import { CityHeaderNavUnstyled } from './unstyled'
import styled from 'styled-components'

export const CityHeaderNav = styled(CityHeaderNavUnstyled)``



// WEBPACK FOOTER //
// ./src/Containers/City/Page/HeaderNav/index.js